import ItemRecentViewPage from '../../components/pages/items/ItemRecentViewPage.vue'
export default {
  components: {
    ItemRecentViewPage
  }
}
